import React from 'react'
import { Row, Col } from 'antd';

import './view.css'

export default function ViewAbout() {
    const items = [
        {
            key: 1,
            icon: <i className="fas fa-database"></i>,
            title: '發展效益',
            content: '幫助學生釐清生涯發展方向及規劃學習的理想地圖，可展現學生升學與就業能力。協助老師瞭解課程將提供學生哪些基本素養與核心能力。協助各層級的開課單位有效地管理及規劃相關課程，建構一套具系統性及層次性之全校課程發展機制。'
        },
        {
            key: 2,
            icon: <i className="fas fa-database"></i>,
            title: '四大主題',
            content: '基本素養課程地圖、核心能力課程地圖、活動課程地圖及學生學習歷程規劃。藉由課程地圖，可瞭解學校的教育目標，以及通識課程和專業課程為學生所設定的核心能力與基本素養。'
        },
        {
            key: 3,
            icon: <i className="fas fa-database"></i>,
            title: '核心功能',
            content: '與「大專校院就業職能平台-UCAN」職涯輔導結合，強化技職教育導引就業之特色，使學生可以更明白學習目標及職涯發展之關聯，並將學習成效以雷達圖展現。建立證照地圖，詳細陳列證照與課程學習關聯圖，能有效引導學生學習方向。列出適合就讀的研究所及報考的國家考試。'
        },

    ]

    return (
        <div id="about" className="block aboutBlock">
            <div className="container-fluid">
                <div className="titleHolder">
                    <h2>關於我們</h2>
                    <p>一群熱愛教育的專業團隊</p>
                </div>
                <div className="contentHolder">
                    <p>我們的提供以下三項服務項目</p>
                </div>
                <Row gutter={[16, 16]}>
                    {
                        items.map((item, index) => {
                            return (
                                <Col md={{ span: 8 }} key={item.key}>
                                    <div >
                                        <div className="content" >
                                            <div className="icon">
                                                {item.icon}
                                            </div>
                                            <h4>{item.title}</h4>
                                            <span>{item.content}</span>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </div>
        </div >
    )
}